module.exports = __webpack_public_path__ + "static/img/507.daf66c86.jpg";